import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppContext } from '../../shared/app-context';
import { SeverityType } from '../../shared/enums/severity-type';
import { APP_METADATA } from '../../shared/constants/app-metadata';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  public appInsights!: ApplicationInsights;
  constructor(private readonly appContext: AppContext) {}
  public initializeApplicationInsightsLog(): void {
    if (
      this.appContext.appInsightConnectionString !== null &&
      this.appContext.appInsightConnectionString !== undefined
    ) {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: this.appContext.appInsightConnectionString,
        },
      });
      this.appInsights.loadAppInsights();
    }
  }

  public logInformationalException(error: Error): void {
    this.appInsights.trackException({
      exception: error,
      severityLevel: SeverityType.Information,
      properties: { ApplicationName: APP_METADATA.applicationName },
    });
  }

  public logWarningException(error: Error): void {
    this.appInsights.trackException({
      exception: error,
      severityLevel: SeverityType.Warning,
      properties: { ApplicationName: APP_METADATA.applicationName },
    });
  }

  public logErrorException(error: Error): void {
    this.appInsights.trackException({
      exception: error,
      severityLevel: SeverityType.Error,
      properties: { ApplicationName: APP_METADATA.applicationName },
    });
  }

  public logCriticalException(error: Error): void {
    this.appInsights.trackException({
      exception: error,
      severityLevel: SeverityType.Critical,
      properties: { ApplicationName: APP_METADATA.applicationName },
    });
  }

  public logTrace(traceMessage: string): void {
    this.appInsights.trackTrace({
      message: traceMessage,
      properties: { ApplicationName: APP_METADATA.applicationName },
    });
  }
}
